module.exports = "<app-alerts></app-alerts>\r\n<angular-loader></angular-loader>\r\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main